import {WorkspaceMember, WorkspaceApiResponse} from 'common/report/queries/app-api/workspaces-client-types';
import workspacesClient, {FilterInclusionType, WorkspaceObj} from 'common/report/queries/app-api/workspaces-client';
import {CreateEntityModalAttrs, ModalReturn} from 'common/widgets/create-entity-modal/types';
import {CreateEntityModal, createEntityModalPromise} from 'common/widgets/create-entity-modal';

export function promptManageWorkspaceModal(
  title: string,
  attrs: Partial<CreateEntityModalAttrs> = {},
  projectId: number = null,
): Promise<ModalReturn> {
  if (projectId) {
    workspacesClient.getWorkspaces({projectId}).then((workspaces) => {
      const cem: CreateEntityModal = document.querySelector(`mp-create-entity-modal[entity-type=workspace]`);
      cem.existingEntityNames = workspaces.map((w) => w.name);
    });
  }

  // TODO I need to create a new API for accessing the element and promise to remove the need to query selector
  return createEntityModalPromise({
    ...attrs,
    'entity-type': `workspace`,
    'modal-title': title,
  });
}

export function getWorkspaceDetailsUrl(workspace: {id: number; projectId: number}): string {
  return `/settings/project/${workspace.projectId}#workspaces/detail/${workspace.id}`;
}

export function toWorkspaceObj(apiResponse: WorkspaceApiResponse): WorkspaceObj {
  return {
    id: apiResponse.id,
    projectId: apiResponse.project_id,
    name: apiResponse.name,
    description: apiResponse.description,
    memberList: apiResponse.member_list.map<WorkspaceMember>((member) => ({
      email: member.email,
      invited: member.invited,
      name: member.name,
    })),
    dataFilters: {
      eventNames: {
        inclusionType:
          (apiResponse.data_filters.event_names.inclusion_type as FilterInclusionType) || FilterInclusionType.Include,
        filter: apiResponse.data_filters.event_names.filter || [],
      },
      userProperties: {operator: `and`, children: [], ...apiResponse.data_filters.user_properties},
      eventProperties: {operator: `and`, children: [], ...apiResponse.data_filters.event_properties},
    },
    teamList: apiResponse.team_list || [],
    createdAt: new Date(apiResponse.created_iso),
    creator: apiResponse.creator_name,
    creatorId: apiResponse.creator_id,
    isDefault: apiResponse.is_default,
    isGlobal: apiResponse.is_global,
    isRestricted: apiResponse.is_restricted,
    isVisible: apiResponse.is_visible,
    hasAllOrgMembers: apiResponse.has_all_org_members,
    membershipApprovalRequired: apiResponse.membership_approval_required,
    canUpdateBasic: apiResponse.can_update_basic,
    canUpdateRestricted: apiResponse.can_update_restricted,
    canUpdateVisibility: apiResponse.can_update_visibility,
  };
}

export function sortWorkspaces(a: WorkspaceObj, b: WorkspaceObj) {
  if (a.projectId < b.projectId) {
    return -1;
  } else if (a.projectId > b.projectId) {
    return 1;
  }

  if (a.isGlobal) {
    return -1;
  } else if (b.isGlobal) {
    return 1;
  }

  if (a.isDefault) {
    return -1;
  } else if (b.isDefault) {
    return 1;
  }

  const aNormalizeName = a.name.toLocaleLowerCase();
  const bNormalizeName = b.name.toLocaleLowerCase();
  return aNormalizeName < bNormalizeName ? -1 : a === b ? 0 : 1;
}
